// @ts-nocheck

import { selectGRBetsFromRound } from '../round';

const { createSelector } = require('reselect');

const selectGRNbActiveBetsFromRound = createSelector(selectGRBetsFromRound, (bets) => bets.length);

const selectGRChipListProps = createSelector([selectGRNbActiveBetsFromRound], (nbActiveBets) => ({
  nbActiveBets,
}));

export default selectGRChipListProps;
